import IovationField from './iovation-field.vue';

export default IovationField;
